// LEGACY PROVIDER - COMMENTED OUT - EdgeDocsCore system replaced by ClientFirst
import React, { useMemo } from 'react';
// import { TypesetterApiClient } from '../features/dms/EdgeDocs/EdgeDocsCore/utils/typesetterApi';
// import { TypesetterApiContext } from '../features/dms/EdgeDocs/EdgeDocsCore/utils/TypesetterApiContext';

interface ApiClientProviderProps {
  children: React.ReactNode;
  client?: any | null; // TypesetterApiClient | null;
}

export const ApiClientProvider: React.FC<ApiClientProviderProps> = ({ children, client }) => {
  // LEGACY LOGIC - COMMENTED OUT - EdgeDocsCore system replaced by ClientFirst
  // const memoClient = useMemo(() => {
  //   if (client) return client;
  //   const baseURL = typeof window !== 'undefined' ? window.location.origin : '';
  //   const getToken = () => localStorage.getItem('edgelex_access_token') || localStorage.getItem('access_token') || '';
  //   try { return new TypesetterApiClient(baseURL, getToken); } catch { return null as any; }
  // }, [client]);

  // return (
  //   <TypesetterApiContext.Provider value={memoClient}>
  //     {children}
  //   </TypesetterApiContext.Provider>
  // );
  
  // REPLACEMENT: Simple passthrough provider
  return <>{children}</>;
};

export default ApiClientProvider;


















